Namespace('Monitoring.LiveReports.RealtimeMap')

class Monitoring.LiveReports.RealtimeMapSidebarLayersView extends Backbone.View
  template: JST["backbone/templates/monitoring/live_reports/realtime_map/realtime_map_sidebar_layers"]

  events:
    'change input[type="checkbox"]': 'onChangeCheckbox'

  initialize: (@options = {}) ->
    @layerNames = @options.layerNames
    @layerVisibilities = @options.layerVisibilities

  render: ->
    @$el.html(@template(@))

  onChangeCheckbox: (evt) ->
    checkbox = $(evt.currentTarget)
    layerName = checkbox.val()
    if checkbox.is(":checked")
      @layerVisibilities[layerName] = true
      @trigger('selected-layer', layerName)
    else
      @layerVisibilities[layerName] = false
      @trigger('deselected-layer', layerName)
